import { render, staticRenderFns } from "./NewConversation.vue?vue&type=template&id=7a2afcf6"
import script from "./NewConversation.vue?vue&type=script&lang=js"
export * from "./NewConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports